import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Container, 
  Typography, 
  Box, 
  Button, 
  Card,
  CardContent
} from '@mui/material';
import { Cancel, Home, ArrowBack } from '@mui/icons-material';

const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Go back to previous page
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Card>
        <CardContent sx={{ textAlign: 'center', p: 4 }}>
          <Cancel sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            Payment Cancelled
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your payment setup was cancelled. You can try again later or contact support if you need assistance.
          </Typography>
          
          <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              onClick={handleGoBack}
              startIcon={<ArrowBack />}
            >
              Try Again
            </Button>
            <Button
              variant="outlined"
              onClick={handleGoToDashboard}
              startIcon={<Home />}
            >
              Go to Dashboard
            </Button>
            <Button
              variant="text"
              onClick={handleGoHome}
            >
              Go Home
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default PaymentCancelPage;

